import { jsx as _jsx } from "react/jsx-runtime";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { routes } from "./configure"; //路由文件
import { ConfigProvider } from "antd";
import zhCN from "antd/locale/zh_CN";
import { equals, find, isEmpty, isNil, map, not } from "ramda";
import { Interceptor } from "./Interceptor";
import { SuspenseLoading } from "@/components/Loading";
ConfigProvider.config({
    prefixCls: "r"
});
function getPropsTags() {
    const dom = document.querySelector("#epr-tags > .app-main");
    if (isNil(dom)) {
        return document.body;
    }
    const div = find((item)=>{
        return equals(item.className, "cache-route") && not(equals(item.style.display, "none"));
    }, Array.from(dom.children));
    if (div) {
        return div;
    }
    return document.body;
}
function hideBody(mutationsList) {
    if (isEmpty(mutationsList)) {
        return;
    }
    const dom = mutationsList[0].target;
    document.body.style.overflow = dom.style.overflow;
// console.log()
}
function getPopupContainer() {
    let wait = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 500;
    let popupDom = document.body;
    let leading = true;
    let observer;
    return ()=>{
        if (!leading) {
            return popupDom;
        }
        setTimeout(()=>{
            leading = true;
        }, wait);
        let _popupDom;
        const popupContainer = localStorage.getItem("popupContainer");
        switch(popupContainer){
            case "body":
                _popupDom = document.getElementById("this-app") ?? document.body;
                break;
            case "props-tags":
                _popupDom = getPropsTags();
                break;
            default:
                _popupDom = document.getElementById("this-app") ?? document.body;
                break;
        }
        leading = false;
        try {
            if (observer && !equals(_popupDom, popupDom)) {
                observer.disconnect();
                observer = undefined;
            }
            if (_popupDom !== document.body && isNil(observer)) {
                observer = new MutationObserver(hideBody);
                observer.observe(_popupDom, {
                    attributeFilter: [
                        "style"
                    ]
                });
            }
        } catch (e) {
            console.log(e);
        }
        popupDom = _popupDom;
        return popupDom;
    };
}
const popupContainer = getPopupContainer();
// 创建 同步路由文件
export const SyncRouter = ()=>{
    return /*#__PURE__*/ _jsx(ConfigProvider, {
        locale: zhCN,
        prefixCls: "r",
        getPopupContainer: popupContainer,
        children: /*#__PURE__*/ _jsx(BrowserRouter, {
            children: /*#__PURE__*/ _jsx(SuspenseLoading, {
                children: /*#__PURE__*/ _jsx(Routes, {
                    children: map((route)=>/*#__PURE__*/ _jsx(Route, {
                            path: route.path,
                            element: /*#__PURE__*/ _jsx(Interceptor, {
                                route: route
                            })
                        }, route.name), routes)
                })
            })
        })
    });
};
